import { render, staticRenderFns } from "./CountryText.vue?vue&type=template&id=50672454&"
import script from "./CountryText.vue?vue&type=script&lang=js&"
export * from "./CountryText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports